import preval from "preval.macro";

const scrollWatchMin = preval`
  // We do this via preval so we don't bundle the whole config
  // just for one string
  const config = require("../../../tailwind.config");
  module.exports = config.theme.screens.md;
`;
const scrollWatchMq = window.matchMedia(`(min-width: ${scrollWatchMin})`);

function parseScrollPadding(value: string): number {
  if (value === "auto") return 0;
  return parseFloat(value);
}

for (const container of document.querySelectorAll(".partner-details")) {
  // Get the sections in this partner details component
  const sections = container.querySelectorAll<HTMLElement>(
    ".partner-details__section"
  );

  // Get the nav items corresponding to each section
  const sectionsToNavItems = new Map<HTMLElement, HTMLElement>();
  for (const section of sections) {
    const navItem = container
      .querySelector(`a[href="#${section.id}"]`)
      ?.closest<HTMLElement>(".partner-details__nav__item");
    if (navItem != null) {
      sectionsToNavItems.set(section, navItem);
    }
  }

  // Update nav item classes based on scroll position
  const updateNavClasses = (): void => {
    // Do nothing if the viewport is narrow
    if (!scrollWatchMq.matches) return;

    // Get viewport metrics
    const viewportHeight = document.documentElement.clientHeight;
    const documentStyle = getComputedStyle(document.documentElement);
    const scrollPaddingTop = parseScrollPadding(documentStyle.scrollPaddingTop);
    const scrollPaddingBottom = parseScrollPadding(
      documentStyle.scrollPaddingBottom
    );

    function viewportCoverage(rect: DOMRect): number {
      return (
        rect.height -
        Math.max(0, scrollPaddingTop - rect.top) -
        Math.max(0, rect.bottom - (viewportHeight - scrollPaddingBottom))
      );
    }

    // Find section with most screen coverage
    let best: [HTMLElement, number] | null = null;
    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      if (best == null) {
        best = [section, viewportCoverage(rect)];
        continue;
      }

      if (rect.top > viewportHeight - scrollPaddingBottom) {
        // Entire element is below viewport;
        // any succeeding ones will also be too low;
        // we're done
        break;
      }

      if (rect.bottom < scrollPaddingTop) {
        // Entire element is above viewport;
        // we can't see it but if we got this far
        // it's better than the previous one
        best = [section, 0];
        continue;
      }

      const coverage = viewportCoverage(rect);
      if (coverage >= best[1]) best = [section, coverage];
    }

    // Do nothing if no best item was found (this should never happen)
    if (best == null) return;

    // Update classes
    for (const section of sections) {
      sectionsToNavItems
        .get(section)
        ?.classList.toggle("active", section === best[0]);
    }
  };

  // Listen for scroll events
  window.addEventListener("scroll", updateNavClasses);

  // Set initial state
  updateNavClasses();
}
